import { createContext } from 'react'

export interface ColorSchemeContextValue {
  isDark: boolean
  toggleColorScheme: () => void
}

export const ColorSchemeContext = createContext<ColorSchemeContextValue | null>(null)
